import { ApiServiceWithSettings, Audience, Authentication } from '../../common'
import { AxiosPromise } from 'axios'
import Relations from '@one/types'
type RelatedDocument = Relations.Relations.RelatedDocument

export class AppRelationsApi extends ApiServiceWithSettings {
  getRelatedDocuments(
    documentId: string,
    documentType: string,
    clientId: string
  ): AxiosPromise<Array<RelatedDocument>> {
    return this.get('/relations/related-documents', {
      params: {
        documentId: documentId,
        documentType: documentType,
        clientId
      },
      authentication: Authentication.REQUIRED,
      aud: Audience.APP
    })
  }
}
